export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-3">
          本站优势
        </h2>
        <p className="text-sm md:text-base text-foreground-500 text-center mb-10 md:mb-14 max-w-xl mx-auto">
          刃牙漫画在线观看，打造极致阅读体验
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          <div className="text-center p-6 md:p-8 rounded-2xl bg-background-50 border border-background-200/70">
            <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center rounded-2xl bg-primary-50">
              <i className="ri-smartphone-line text-2xl text-primary-500"></i>
            </div>
            <h3 className="text-lg font-heading text-foreground-950 mb-3">下拉式阅读</h3>
            <p className="text-sm text-foreground-500 leading-relaxed">刃牙漫画下拉式全集排版，无需翻页点击，一滑到底沉浸畅读。无论手机还是桌面，流畅丝滑的刃牙漫画在线阅读体验。</p>
          </div>

          <div className="text-center p-6 md:p-8 rounded-2xl bg-background-50 border border-background-200/70">
            <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center rounded-2xl bg-accent-50">
              <i className="ri-download-cloud-2-line text-2xl text-accent-500"></i>
            </div>
            <h3 className="text-lg font-heading text-foreground-950 mb-3">无需下载</h3>
            <p className="text-sm text-foreground-500 leading-relaxed">刃牙漫画免费在线观看，打开即读。不占手机存储空间，刃牙漫画全集随时在线访问，走到哪看到哪。</p>
          </div>

          <div className="text-center p-6 md:p-8 rounded-2xl bg-background-50 border border-background-200/70">
            <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center rounded-2xl bg-secondary-50">
              <i className="ri-shield-flash-line text-2xl text-secondary-500"></i>
            </div>
            <h3 className="text-lg font-heading text-foreground-950 mb-3">高清纯净</h3>
            <p className="text-sm text-foreground-500 leading-relaxed">刃牙漫画免费在线阅读，高清画质还原板垣恵介原作的每一笔线条。纯净无广告，专注刃牙漫画在线看体验。</p>
          </div>
        </div>
      </div>
    </section>
  );
}